export const generatePublicImagePath = ({
  type,
  name,
  src,
  fileExtension = 'png',
  baseUrl,
}: {
  type?: string;
  name?: string;
  src?: string;
  fileExtension?: string;
  baseUrl?: string;
}) => {
  const currentOrigin = window.location.origin;
  let publicImagePath = '';
  let origin = '';

  if (currentOrigin.includes(`http://localhost`)) {
    origin += '/public/images';
  } else {
    origin += `${baseUrl || ''}/images`;
  }

  if (src) {
    publicImagePath = `${origin}/${src}`;
  } else {
    switch (type) {
      case 'resourceType':
        publicImagePath = `${origin}/${type}/${name
          ?.split('::')
          ?.join('-')
          .toLowerCase()}.${fileExtension}`;
        break;
      case 'framework':
        publicImagePath = `${origin}/${type}/${name?.toLowerCase()}.${fileExtension}`;
        break;
      default:
        publicImagePath = `${origin}/${type}/${name?.toLowerCase()}.${fileExtension}`;
    }
  }

  return publicImagePath;
};
